import { createSlice } from '@reduxjs/toolkit/react';

import type { Pickup } from '@/modules/pickup/domain/Pickup';
import {
  fetchPickups,
  findPickups,
  savePickup
} from '@/modules/pickup/infrastructure/PickupReduxRepository';

interface InitialState {
  data: Pickup[];
  isLoading: boolean;
}

const initialState: InitialState = {
  data: [],
  isLoading: false
};

const PickupSlice = createSlice({
  name: 'pickup',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(savePickup.fulfilled, (state, action) => {
        const isEdited = state.data.find(
          (pickup) => pickup.id === action.payload.id
        );
        if (isEdited) {
          state.data = state.data.map((pickup) =>
            pickup.id === action.payload.id ? action.payload : pickup
          );
        } else {
          state.data.push(action.payload);
        }
      })
      .addCase(fetchPickups.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPickups.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(findPickups.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(findPickups.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
});

export const pickupReducer = PickupSlice.reducer;
